"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = returnFalse;

function returnFalse() {
  return false;
}